import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_LinkedHashSet(_this__u8e3s4) {
}
var LinkedHashSetClass;
function LinkedHashSet() {
  if (LinkedHashSetClass === VOID) {
    class $ extends HashSet() {
      static x2() {
        var $this = this.la();
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static h3(elements) {
        var $this = this.ma(elements);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static jc(initialCapacity, loadFactor) {
        var $this = this.oa(initialCapacity, loadFactor);
        init_kotlin_collections_LinkedHashSet($this);
        return $this;
      }
      static i2(initialCapacity) {
        return this.jc(initialCapacity, 1.0);
      }
      t6() {
        return this.i3_1.v9();
      }
    }
    initMetadataForClass($, 'LinkedHashSet', $.x2, VOID, [HashSet(), KtMutableSet()]);
    LinkedHashSetClass = $;
  }
  return LinkedHashSetClass;
}
//region block: exports
export {
  LinkedHashSet as LinkedHashSet2tkztfx86kyx2,
};
//endregion

//# sourceMappingURL=LinkedHashSet.mjs.map
